import { executeRequest, JFSRequest } from '@jfs/network'
import {
  dateFormatter,
  DateFormatTypes,
  fromDateTime,
  getAcceptableStatus,
  isSuccessResponse,
  toDateTime,
} from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const parser = (dataList: any, count: number, isAudit: boolean) => {
  let parsedList: any[] = []
  dataList?.map((data) => {
    parsedList.push(
      isAudit
        ? {
            applicationId: data?.applicationId,
            auditType: data?.auditType,
            applicationStatus: data?.applicationStatus === 'Pending' ? 'Pending For Approval' : data?.applicationStatus,
            assignee: data?.assignee,
            authorisedSignatory: data?.authorisedSignatory,
            beneficialOwnerDetails: data?.beneficialOwnerDetails,
            businessProfile: data?.businessProfile,
            comments: data?.comments,
            createdAt: dateFormatter(data?.createdAt, DateFormatTypes.TIME_STAMP),
            createdBy: data?.createdBy,
            directorDetails: data?.directorDetails,
            identificationNumber: data?.identificationNumber,
          }
        : {
            legalName: data?.inputDto?.legalName,
            creationDate: dateFormatter(data?.createdAt, DateFormatTypes.TIME_STAMP),
            mobileNumber:
              data?.inputDto?.groupContacts?.[0]?.mobileNumber ??
              data?.inputDto?.contactDetails?.[0]?.mobileNumber ??
              'NA',
            requestType: data?.inputDto?.type,
            status: data?.applicationStatus,
            isSelected: data?.isSelected ?? false,
            assignee: data?.claimedByUser?.username ?? 'NA',
            applicationId: data?.processInstanceId,
            groupAddress: data?.inputDto?.groupAddress,
            groupContacts: data?.inputDto?.groupContacts,
            type: data?.requestType,
            brandName: data?.brandName,
            businessName:
              data?.requestType === 'GROUP_ADD' || data?.requestType === 'SUBGROUP_ADD'
                ? data?.inputDto?.brandName
                : data?.inputDto?.businessName,
            addressDetails: data?.inputDto?.addressDetails,
            contactDetails: data?.inputDto?.contactDetails,
            identificationNumber: data?.inputDto?.identificationNumber,
            gstDetails: data?.inputDto?.gstDetails,
            settlementDetails: data?.inputDto?.settlementDetails,
            feePackageDetails: data?.inputDto?.feePackageDetails,
            programCategoryDetails: data?.inputDto?.programCategoryDetails,
            deviceDetails: data?.inputDto?.deviceDetails,
            businessProfile: data?.inputDto?.businessProfile,
            source: data?.source,
            parentEntityIdentificationNumber: data?.inputDto?.parentEntityIdentificationNumber,
            subGroupIdentificationNumber: data?.inputDto?.subGroupIdentificationNumber,
            applicationStatus: data?.applicationState === 'Pending' ? 'Pending For Approval' : data?.applicationState,
            errorReason: data?.errorReason,
            errorTask: data?.errorTask,
            inProgressTask: data?.inProgressTask,
            completedTaskList: data?.completedTaskList,
            applicationType: data?.applicationType,
            comments: data?.comments,
            terminalDetails: data?.terminalDetails,
            jfsUserid: data?.jfsUserid,
            uploadId: data?.inputDto?.uploadId,
          },
    )
  })
  return { list: parsedList, count: count }
}

const responseParser = (response: any, isAudit: boolean) => {
  const data = isSuccessResponse(response)
  return parser(data?.processInstances, data?.totalItems, isAudit)
}

const getGlobalCheckerListReq = (
  selectedDateInfo: any,
  pagination: any,
  applicationStatus: any,
  tokens: any,
  auditType: any,
  searchBy?: string,
  searchKey?: string,
  isAudit?: boolean,
) => {
  console.log(
    'selectedDateInfo: ',
    JSON.parse(JSON.stringify(selectedDateInfo)),
    JSON.parse(JSON.stringify(pagination)),
  )
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGlobalCheckerList),
    method: 'POST',
    cache: false,
    body: {
      configParams: {
        page: searchBy && searchBy?.length > 0 && searchKey?.length > 0 ? 1 : pagination.number,
        recordCount: 10,
      },
      inputFilters: {
        endDateTime:
          selectedDateInfo.toDate !== new Date(Date.now())
            ? toDateTime(new Date(Date.now()))
            : toDateTime(selectedDateInfo.toDate),
        startDateTime: fromDateTime(selectedDateInfo.fromDate),
        ...(applicationStatus.length > 0 &&
          !applicationStatus?.includes('ALL') && {
            status: getAcceptableStatus(applicationStatus),
          }),
        ...(searchBy?.length > 0 && searchKey?.length > 0 && { [searchBy]: searchKey }),
        ...(auditType.length > 0 &&
          !auditType?.includes('ALL') && {
            auditType: auditType,
          }),
      },
      ...(isAudit && { processDefinitionKeyType: 'AUDIT' }),
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then((response) => responseParser(response, isAudit))
    .catch((error) => {
      throw error
    })
}

export { getGlobalCheckerListReq }
